import v35, { GenerateUUID } from './support/v35';
import sha1 from './support/sha1';

export const uuidv5: GenerateUUID = v35('v5', 0x50, sha1);
export default uuidv5;
